import React from 'react';

const MLProgressModalContext = React.createContext({
    progressModalState: {},
    updateProgressModalState: () => {}
});


const MLProgressModalReducer = function(state, payload){
    const {
        title,
        initDelay,
        type,
        isCountRequired
    } = payload;

    switch(type){
        case 'ACTIVATE': {
            return {
              active: true,
              title,
              initDelay,
              count: isCountRequired ? state.count + 1:state.count
            };
        }
        case 'DEACTIVATE': {
            const nextCount = Math.max(state.count - 1, 0);
            
            return {
              active: nextCount > 0,
              count: nextCount
            };
        }
        case 'RESET': 
            return {
                active: false,
                count: 0
            };
        default:
            return state;
    };
};

export {
    MLProgressModalContext,
    MLProgressModalReducer
};